import { Text, type TextProps } from '@chakra-ui/react';
import { useT } from '../i18n';
import type { OpenedApp, OpenedE2EE } from '../lib/e2ee/session';

/**
 * Opened from an older (v1) envelope (M76, D328): its sender, type and edit
 * aren't bound, so the app doesn't vouch for them, wherever it shows.
 */
export function isUnbound(item: {
  e2ee?: OpenedE2EE | null;
  e2eeApp?: OpenedApp | null;
}): boolean {
  return item.e2ee?.bound === false || item.e2eeApp?.bound === false;
}

/** The quiet mark beside unbound content: a message's or a record's words. */
export function UnboundMark({
  record = false,
  ...props
}: { record?: boolean } & TextProps) {
  const t = useT();
  return (
    <Text
      data-testid="unbound-mark"
      fontSize="11px"
      lineHeight="14px"
      color="muted"
      fontStyle="italic"
      {...props}
    >
      {t(record ? 'apps.record.unbound' : 'chat.message.unbound')}
    </Text>
  );
}
